import { useCallback, useMemo } from 'react';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
export const useReportTableSorting = (columns) => {
    const [sortParam, setSortParam] = useQueryParam('sort', withDefault(StringParam, undefined));
    const [orderParam, setOrderParam] = useQueryParam('order', withDefault(StringParam, 'desc'));
    const availableColumns = useMemo(() => {
        return columns.filter((column) => ['money', 'number', 'date', 'string', 'percentage'].includes(column.type));
    }, [columns]);
    const availableColumnIds = useMemo(() => {
        return availableColumns.map((column) => column.id);
    }, [availableColumns]);
    const sorting = useMemo(() => {
        if (!sortParam || !availableColumnIds.includes(sortParam)) {
            return undefined;
        }
        const direction = orderParam === 'asc' ? 'asc' : 'desc';
        return {
            columnId: sortParam,
            direction,
        };
    }, [sortParam, orderParam, availableColumnIds]);
    const onSortingChange = useCallback((columnId) => {
        if (!availableColumnIds.includes(columnId)) {
            return;
        }
        if (!sorting || sorting.columnId !== columnId) {
            setSortParam(columnId);
            setOrderParam('desc');
            return;
        }
        const newDirection = sorting.direction === 'desc' ? 'asc' : 'desc';
        setOrderParam(newDirection);
    }, [setSortParam, setOrderParam, availableColumnIds, sorting]);
    return {
        sorting,
        onSortingChange,
    };
};
